import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Mutation from '@dietlabs/components/src/Apollo/Mutation';
import deepClone from 'utils/deepClone';
import { formatIsoDate } from 'utils/dateFormatter';

import mutation from './HydrationDayChangeGoalMutation';

class HydrationDayChangeGoalConnectorApollo extends Component {
    static propTypes = {
        children: PropTypes.func.isRequired,
        date: PropTypes.instanceOf(Date).isRequired,
        // eslint-disable-next-line react/forbid-prop-types
        queryResult: PropTypes.object.isRequired,
    };

    createChangeGoal = mutate => (goal, unit) => {
        const variables = {
            date: formatIsoDate(this.props.date),
            goal,
            unit,
        };

        const { hydrationDay: hydrationDayResult, ...meResult } = deepClone(
            this.props.queryResult.me
        );
        const optimisticResponse = {
            me: {
                ...meResult,
                hydrationDayChangeGoal: {
                    ...hydrationDayResult,
                    goal: {
                        __typename: 'Volume',
                        value: goal,
                        unit,
                    },
                },
            },
        };

        return mutate({
            variables,
            optimisticResponse,
        });
    };

    render() {
        const { children } = this.props;

        return (
            <Mutation mutation={mutation}>
                {(mutate, { data: rawData }) =>
                    children(this.createChangeGoal(mutate), {
                        data: rawData
                            ? rawData.me.hydrationDayChangeGoal
                            : null,
                    })
                }
            </Mutation>
        );
    }
}

export default HydrationDayChangeGoalConnectorApollo;
